import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import { WritableStream } from 'web-streams-polyfill/ponyfill';
import streamSaver from 'streamsaver';
import constants from '../constants';
import { translate } from '../Services/translation';
// If the WritableStream is not available (Firefox, Safari), take it from the polyfill
if (!window.WritableStream) {
    streamSaver.WritableStream = WritableStream;
}

export const GENERIC_EXPORT_LOAD = 'GENERIC_EXPORT_LOAD';
export const GENERIC_EXPORT_LOAD_ERROR = 'GENERIC_EXPORT_LOAD_ERROR';
export const GENERIC_EXPORT_RECEIVE = 'GENERIC_EXPORT_RECEIVE';
export const GENERIC_EXPORT_STORE_TYPE = 'GENERIC_EXPORT_STORE_TYPE';
export const GENERIC_EXPORT_STORE_TYPE_INDEX = 'GENERIC_EXPORT_STORE_TYPE_INDEX';
export const GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS = 'GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS';
export const GENERIC_EXPORT_STORE_UPDATE_SELECTED_DATA_SOURCES = 'GENERIC_EXPORT_STORE_UPDATE_SELECTED_DATA_SOURCES';
export const GENERIC_EXPORT_STORE_UPDATE_CUSTOMER_DATA = 'GENERIC_EXPORT_STORE_UPDATE_CUSTOMER_DATA';

const rootRoute = '/api/genericExport/';
const genericLoaderId = 'genericLoader';
const contentType_Pdf = 'application/pdf'; 

export const load = () => (dispatch, getState) => {

    const thisEl = document.getElementById("genericExport");
    const areaType = thisEl.dataset.areatype;
    dispatch(activateLoader());
    return post(rootRoute + 'getExportObjects', areaType) 
        .then(response => response.json())
        .then(data => dispatch(receive(data)))
        .then(data => dispatch(deactivateLoader()))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const downloadPdf = (data, fileName = 'file') => (dispatch, getState) => {
    return downloadFile(data, fileName);
}

export const downloadFile = (data, fileName) => {
    fileName = fileName + ".pdf";

    const linkSource = `data:${contentType_Pdf};base64,${data.base64}`;
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);

    downloadLink.click();
    downloadLink.remove();

    return true;
}

export const createOrderPdf = (orderId, isOffer, dispatch) => {

    const createObject = { exportType: 'pdf', id: orderId, method: isOffer ? 'PdfOffer' : 'OrderAcknowledgement', responseType: 'Download', areaTypeName: 'order', saveCustomerFields: false };
    const loaderEl = document.getElementById(genericLoaderId);
    if (loaderEl) {
        loaderEl.classList.add("active");
    }

    return post(rootRoute + 'exportData', createObject)
        .then(response => response.json())
        //.then(response => response.blob())
        .then(data => {
            var link = document.createElement('a');
            var timestamp = +new Date;
            link.href = "/.File?r=" + timestamp;
            link.download = data.fileName;
            document.body.appendChild(link);
            link.click();
            if (loaderEl) {
                loaderEl.classList.remove("active");
            }
        })
        .catch(ex => catchError(ex, error => loadError(error)));
}

export const exportData = (exportType, method, responseType, exportObjectIndex) => (dispatch, getState) => {

    // Handle export differently reg to type expected.
    const pdfCustomerData = { ...getState().genericExport.pdfCustomerData };
    const exportObjects = [...getState().genericExport.exportObjects];
    const exportObject = exportObjects[exportObjectIndex];
    const customerExportObjects = [...exportObject.customerExportFields];
    const areaTypeName = getState().genericExport.areaTypeName;
    const saveCustomerFieldsCheckbox = document.getElementById('saveCustomerFields');
    const dataSources = getState().genericExport.selectedDataSources;
    const customerFieldsNameEl = document.getElementById('customerFieldsName');


    let saveCustomerFields = false;
    let customerFieldsName = customerFieldsNameEl ? customerFieldsNameEl.value : '';

    dispatch(activateLoader());

    // If no custom fields are set: Show all
    // --------------------------------------
    if (exportType !== "files" && !customerExportObjects.length) {
        exportObject.exportFields.map((exportField) => {
            let fieldData = {
                fieldDataLeft: {},
                fieldDeliminator: '',
                fieldDataRight: {},
                fieldHeading: exportField.exportObjectName,
            };

            fieldData.fieldDataLeft = {
                exportObjectId: exportField.exportObjectId,
                exportObjectName: exportField.exportObjectName,
                exportObjectType: exportField.exportObjectType,
                isBaseProduct: exportField.isBaseProduct,
                exportObjectImageWidth: '',
                exportObjectImageHeight: ''
            }
            customerExportObjects.push(fieldData);
        });
    } // Only save data if there are chosen fields...
    else if (saveCustomerFieldsCheckbox && saveCustomerFieldsCheckbox.checked) {
        saveCustomerFields = true;
    }
    //const createObject = JSON.stringify({ exportType, method, responseType, areaTypeName, saveCustomerFields, customerExportFields: [...customerExportObjects] });
    const createObject = { exportType, method, responseType, areaTypeName, saveCustomerFields, dataSources, customerExportFields: [...customerExportObjects], pdfCustomerData, customerFieldsName };

    exportType = exportType.toLowerCase();
    responseType = responseType.toLowerCase();
    var timeoutId;

    switch (responseType) {
        case 'download':
            return post(rootRoute + 'exportData', createObject)
                .then(response => response.json())
                .then(data => {
                    var link = document.createElement('a');
                    link.href = '/.File';
                    link.download = '';
                    document.body.appendChild(link);
                    link.click();

                    timeoutId = setTimeout(function () {
                        get(rootRoute + 'status')
                            .then(response => response.json())
                            .then(response => {
                                if (response === 'false') {
                                    alert("No file is generated");
                                    document.body.removeChild(link);
                                    clearTimeout(timeoutId);
                                }
                                dispatch(deactivateLoader());
                            });
                    },
                        1000);

                    if (saveCustomerFields) {
                        // Add to saved list
                        
                        let exportObjects = [...getState().genericExport.exportObjects];
                        if (exportObjects[exportObjectIndex] ) {

                            const newObj = {
                                customerFieldsName,
                                fields: customerExportObjects
                            }

                            const customerExportFieldsListExists = exportObjects[exportObjectIndex].customerExportFieldsList.filter(x => x.customerFieldsName === customerFieldsName);

                            if (!customerExportFieldsListExists || customerExportFieldsListExists.length < 1) {
                                let customerExportFieldsList = exportObjects[exportObjectIndex].customerExportFieldsList.push(newObj);
                                
                                exportObjects[exportObjectIndex] = { ...exportObjects[exportObjectIndex], ...customerExportFieldsList, customerExportFieldName: customerFieldsName };

                                dispatch(storeUpdateExportObjects(exportObjects));
                            }
                        }
                    }
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))));
        default:
            dispatch(deactivateLoader());
            return null;
    }
}

export const activateLoader = () => (dispatch, getState) => {
    const loaderEl = document.getElementById(genericLoaderId);
    if (loaderEl) {
        loaderEl.classList.add("active");
    }
    return true;
}

export const deactivateLoader = () => (dispatch, getState) => {
    const loaderEl = document.getElementById(genericLoaderId);
    if (loaderEl) {
        setTimeout(function () {
            loaderEl.classList.remove("active");
        }, 100);
    }
    return true;
}

export const handleDownload = () => {
    return;
}

export const loadError = error => (dispatch, getState) => {
    const loaderEl = document.getElementById(genericLoaderId);
    if (loaderEl) {
        setTimeout(function () {
            loaderEl.classList.remove("active");
        }, 100);
    }

    dispatch({
        type: GENERIC_EXPORT_LOAD_ERROR,
        payload: {
            error
        }
    });
}

export const receive = data => {

    const selectedDataSources = [];
    var newItem = null;
    if (data.dataSources[0].type !== 'Cart') {
        data.dataSources.unshift({ type: 'Spacer', id: '---', name: '-----------' });
    }
    else {
        selectedDataSources.push(data.dataSources[0]);
    }

    if (constants.dataSource === 'Category') {
        newItem = { type: constants.dataSource, id: constants.dataSourceId + '|' + window.location.search.substring(1), name: translate('common.genericexport.datasource.' + constants.dataSource.toLowerCase()) };
    }
    else if (constants.dataSource === 'BaseProduct') {
        newItem = { type: constants.dataSource, id: constants.dataSourceId, name: translate('common.genericexport.datasource.' + constants.dataSource.toLowerCase()) };
    }
    else if (constants.dataSource === 'SearchResult') {
        newItem = { type: constants.dataSource, id: window.location.search.substring(1), name: translate('common.genericexport.datasource.searchresult') };
    }

    if (newItem) {
        data.dataSources.unshift(newItem);
        selectedDataSources.push(newItem);
    }

    return ({
        type: GENERIC_EXPORT_RECEIVE,
        payload: {
            exportObjects: data.exportObjects,
            areaTypeName: data.areaTypeName,
            dataSources: data.dataSources,
            pdfCustomerData: data.pdfCustomerData,
            selectedDataSources: selectedDataSources

            //exportFieldItems: data.exportFieldItem.exportDataObject
        }
    });
}

export const setActiveExportType = (exportTypeName, activeObjectIndex) => (dispatch, getState) => {

    // Change Active Export Type
    dispatch(storeActiveExportType(exportTypeName));

    // Set active index
    dispatch(storeActiveObjectIndex(activeObjectIndex));
    //alert(activeObjectIndex);
    // Update 
    let exportObjects = [...getState().genericExport.exportObjects];
    const type = exportObjects[activeObjectIndex].exportFields[0] ? exportObjects[activeObjectIndex].exportFields[0].exportObjectType : null;
    const customerExportFields = [];

    exportObjects[activeObjectIndex] = { ...exportObjects[activeObjectIndex], activeFieldType: type, customerExportFields, customerExportFieldName: '' };

    dispatch(storeUpdateExportObjects(exportObjects));
}

export const setActiveExportFields = (customerExportFieldName, activeObjectIndex) => (dispatch, getState) => {
    let exportObjects = [...getState().genericExport.exportObjects];

    if (exportObjects[activeObjectIndex] && exportObjects[activeObjectIndex].customerExportFieldsList.length > 0) {

        const customerExportFieldsList = exportObjects[activeObjectIndex].customerExportFieldsList.filter(x => x.customerFieldsName === customerExportFieldName);

        let customerExportFields = [];
        if (customerExportFieldsList && customerExportFieldsList.length > 0) {
            customerExportFields = customerExportFieldsList[0].fields;
        }
        exportObjects[activeObjectIndex] = { ...exportObjects[activeObjectIndex], customerExportFieldName: customerExportFieldName, customerExportFields };

        dispatch(storeUpdateExportObjects(exportObjects));
    }
}

export const removeExportFields = (customerExportFieldName, activeObjectIndex) => (dispatch, getState) => {


    return post(rootRoute + 'deleteConfiguration', customerExportFieldName)
        .then(response => response.json())
        .then(data => {
            // Remove from list...
            let exportObjects = [...getState().genericExport.exportObjects];
            if (exportObjects[activeObjectIndex] && exportObjects[activeObjectIndex].customerExportFieldsList.length > 0) {

                const customerExportFieldsList = exportObjects[activeObjectIndex].customerExportFieldsList.filter(x => x.customerFieldsName !== customerExportFieldName);

                let customerExportFields = [];
                if (customerExportFieldName === exportObjects[activeObjectIndex].customerExportFieldName) {
                    exportObjects[activeObjectIndex] = { ...exportObjects[activeObjectIndex], customerExportFieldsList, customerExportFieldName: '', customerExportFields: [] };
                } else {
                    exportObjects[activeObjectIndex] = { ...exportObjects[activeObjectIndex], customerExportFieldsList };
                }

                dispatch(storeUpdateExportObjects(exportObjects));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));

    

   
}

export const addFieldData = (fieldIdLeft, fieldDataLeft, fieldObjectTypeLeft, fieldDeliminator, fieldIdRight, fieldDataRight, fieldObjectTypeRight, fieldHeading, imageWidth, imageHeight, isBaseProductLeft, isBaseProductRight, exportFieldDescriptionLeft, exportFieldDescriptionRight, exportObjectIndex) => (dispatch, getState) => {

    let fieldData = {
        fieldDataLeft: {},
        fieldDeliminator,
        fieldDataRight: {},
        fieldHeading
    };

    if (fieldDataLeft !== undefined && fieldDataLeft.length > 0) {
        fieldData.fieldDataLeft = {
            exportObjectId: fieldIdLeft,
            exportObjectName: fieldDataLeft,
            exportObjectType: fieldObjectTypeLeft,
            exportObjectImageWidth: imageWidth,
            exportObjectImageHeight: imageHeight,
            isBaseProduct: isBaseProductLeft,
            exportFieldDescription: exportFieldDescriptionLeft ? exportFieldDescriptionLeft : ""
        }
    }
    if (fieldDataRight !== undefined && fieldDataRight.length > 0) {
        fieldData.fieldDataRight = {
            exportObjectId: fieldIdRight,
            exportObjectName: fieldDataRight,
            exportObjectType: fieldObjectTypeRight,
            isBaseProduct: isBaseProductRight,
            exportFieldDescription: exportFieldDescriptionRight ? (fieldData.fieldDataLeft.exportFieldDescription.length > 0 ? " & " : "") + exportFieldDescriptionRight : ""
        }
    }

    //let exportObjects = deepCloneObject(getState().genericExport.exportObjects);
    let exportObjects = [...getState().genericExport.exportObjects];
    if (exportObjects[exportObjectIndex].customerExportFields.find(element => element.fieldDataLeft.exportObjectId === fieldData.fieldDataLeft.exportObjectId))
        alert("Item already added");
    else
        exportObjects[exportObjectIndex].customerExportFields.push(fieldData);

    return dispatch(storeUpdateExportObjects(exportObjects));
}

export const addDataSource = (selectedDataSource) => (dispatch, getState) => {
    let selectedDataSources = [...getState().genericExport.selectedDataSources];
    selectedDataSources.push(selectedDataSource);
    return dispatch(storeUpdateSelectedDataSources(selectedDataSources));
}

export const removeDataSource = (dataSourceIndex) => (dispatch, getState) => {
    let selectedDataSources = [...getState().genericExport.selectedDataSources];
    selectedDataSources.splice(dataSourceIndex, 1);
    dispatch(storeUpdateSelectedDataSources(selectedDataSources));
}

export const eraseAllFieldData = (exportObjectIndex) => (dispatch, getState) => {
    //let exportObjects = deepCloneObject(getState().genericExport.exportObjects);
    let exportObjects = [...getState().genericExport.exportObjects];
    exportObjects[exportObjectIndex].customerExportFields = [];
    dispatch(storeUpdateExportObjects(exportObjects));
}

export const removeFieldData = (exportObjectIndex, fieldIndex) => (dispatch, getState) => {
    //let exportObjects = deepCloneObject(getState().genericExport.exportObjects);
    let exportObjects = [...getState().genericExport.exportObjects];
    exportObjects[exportObjectIndex].customerExportFields.splice(fieldIndex, 1);
    dispatch(storeUpdateExportObjects(exportObjects));
}

export const changeActiveFieldType = (objectIndex, type) => (dispatch, getState) => {
    let exportObjects = [...getState().genericExport.exportObjects];
    exportObjects[objectIndex] = { ...exportObjects[objectIndex], activeFieldType: type };
    dispatch(storeUpdateExportObjects(exportObjects));
}

export const storeActiveExportType = exportType => {
    return ({
        type: GENERIC_EXPORT_STORE_TYPE,
        payload: {
            activeType: exportType
        }
    });
}

export const storeActiveObjectIndex = activeObjectIndex => {
    return ({
        type: GENERIC_EXPORT_STORE_TYPE_INDEX,
        payload: {
            activeObjectIndex
        }
    });
}

export const storeUpdateExportObjects = exportObjects => {
    return ({
        type: GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS,
        payload: {
            exportObjects
        }
    });
}

export const storeUpdateCustomerData = (objectName, objectValue) => (dispatch, getState) => {
    //[objectName]: objectValue
    let pdfCustomerData = { ...getState().genericExport.pdfCustomerData };
    pdfCustomerData[objectName] = objectValue;

    dispatch({
        type: GENERIC_EXPORT_STORE_UPDATE_CUSTOMER_DATA,
        payload: {
            pdfCustomerData
        }
    });
}

export const storeUpdateSelectedDataSources = selectedDataSources => {
    return ({
        type: GENERIC_EXPORT_STORE_UPDATE_SELECTED_DATA_SOURCES,
        payload: {
            selectedDataSources
        }
    });
}

export const toggleExportDone = () => {

    return ({
        type: GENERIC_EXPORT_RECEIVE,
        payload: {
            exportDone: false
        }
    });
}

export const dataSent = () => {

    return ({
        type: GENERIC_EXPORT_RECEIVE,
        payload: {
            exportDone: true
        }
    });
}

function deepCloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}